var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-content"},[_vm._l((_vm.elements),function(element,i){return [(element.nodeName.toLowerCase()==='#text')?[_vm._v("\n      "+_vm._s(element.data)+"\n    ")]:[_c('content-element',{key:i,attrs:{"html":_vm.parseElementToHtml(element)},on:{"click-image":_vm.handleImageClick,"load-image":_vm.handleImageLoad}})]]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }